import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import ContactFormCmp from "../../components/ContactFormCmp";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const ArchitectureDesign = () => {

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        location: "",
        budget: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const submitMessage = (e) => {
        e.preventDefault();
        // console.log(formData);
        // API call or validation logic here
        alert(
            'Due to some technical issues, we could not process your Form Submission.'
        );

        setFormData({
            fullName: "",
            email: "",
            phone: "",
            location: "",
            budget: "",
            message: "",
        });
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <>
            {/*Start breadcrumb area paroller*/}
            <section className="breadcrumb-area">
                <div className="breadcrumb-area-bg" style={{ backgroundImage: 'url(/assets/images/services/banners/Architecture.jpg)' }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="inner-content">
                                <div className="title">
                                    <h2>Architecture Design</h2>
                                </div>
                                <div className="breadcrumb-menu">
                                    <ul>
                                        <li><Link to="/">Home</Link></li>
                                        <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                                        <li className="active">Architecture Design</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*End breadcrumb area*/}

            <div className="service-details-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="service-details-sec1">
                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <img className="serv-im" src="/assets/images/Group2.png" alt="Architecture Design" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h3 className="serv-head">Architecture Design</h3>
                                        <p className="serv-txt">Our architecture design services cover the entire building process, from initial concept to detailed
                                            construction drawings. We work closely with clients to understand their vision and transform it into
                                            functional, aesthetically pleasing, and sustainable spaces that combine creativity, practicality, and lasting
                                            architectural value.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="serv-sec2">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="serv-sec2-leftsec">
                                    <h3 className="serv-sec2-leftsec-head">Why Choose Our Architecture Services?</h3>
                                    <p className="serv-sec2-leftsec-txt">Our architecture design services encompass the complete spectrum of building design, from initial concept to final construction drawings. We work closely with clients to understand their vision and translate it into functional, beautiful spaces that stand the test of time.</p>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Interior Design</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Elevation Design</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Landscape Architecture</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Vastu - Compliant Designs</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Renovation & Remodeling</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Anti Earthquake Design</p>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="serv-sec-3box">
                                        <h3 className="serv-sec-3box-head">What We Offer</h3>
                                        <ul className="serv-sec-3box-ul">
                                            <li>1. Interior</li>
                                            <li>2. Elivations</li>
                                            <li>3. Landscape Designs</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='contactus-section2Right'>
                                    <h3 className='contactus-section2RightHead'>Contact for Service</h3>
                                    <p className='contactus-section2Righttxt'>Fill in your details and we'll get back to you within 24 hours.</p>
                                    <ContactFormCmp serviceName="Architecture Planning" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default ArchitectureDesign;